import React from "react";

import cx from "classnames";

import styles from "./RatingBar.scss";

export interface RatingButtonProps {
  /**
   * The numeric value of this rating button
   */
  value: number;
  /**
   * The currently selected rating value
   */
  currentRating?: number;
  /**
   * The start of the rating scale
   */
  scaleStart: number;
  /**
   * The end of the rating scale
   */
  scaleEnd: number;
  /**
   * Handler for when the button is clicked
   */
  onClick?: () => void;
  /**
   * Whether the button should show error styling
   */
  hasError: boolean;
  /**
   * Whether the button is disabled
   */
  disabled: boolean;
}

export function RatingButton({
  value,
  currentRating,
  scaleStart,
  scaleEnd,
  onClick,
  hasError,
  disabled,
}: RatingButtonProps): JSX.Element {
  const isFilled = currentRating !== undefined && currentRating === value;
  const isStart = value === scaleStart;
  const isEnd = value === scaleEnd;
  const buttonClass = cx(styles["rating-button"], {
    [styles["rating-button--selected"]]: isFilled,
    [styles["rating-button--start"]]: isStart,
    [styles["rating-button--end"]]: isEnd,
    [styles.error]: hasError,
  });

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={buttonClass}
      data-testid={`rating-button-${value}`}
      type="button"
    >
      {value}
    </button>
  );
}
